import { makeStyles } from '@material-ui/core';

import styled from 'shared/utils/styled';

export const List = styled('ul')({
  margin: 0,
  padding: 0,
  listStyle: 'none',
});

export const ListItem = styled('li')({
  marginBottom: 10,
  '&:last-child': {
    marginBottom: 0,
  },
});

export const useStyles = makeStyles((theme) => ({
  container: {
    flex: 1,
    '&:first-child': {
      marginRight: 30,
    },
    [theme.breakpoints.down(theme.size.sm)]: {
      maxWidth: '100%',
      margin: 0,
      marginBottom: 30,
      '&:first-child': {
        marginRight: 0,
      },
      '&:last-child': {
        margin: 0,
      },
    },
  },
  zeroPadding: {
    padding: 0,
  },
  boxWrapper: {
    maxWidth: '100%',
    flexBasis: '100%',
    marginRight: 0,
    '&:nth-last-child(-n+2)': {
      marginBottom: 30,
    },
    '&:last-child': {
      marginBottom: 0,
    },
  },
  tableBoxWrapper: {
    marginTop: 30,
  },
  tableBox: {
    minHeight: 'auto',
    background: '#fff',
  },
  documentsBox: {
    minHeight: 80,
  },
  centerBox: {
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
